import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Progress } from '@/components/ui/progress';
import { ServicoMaisVendido, formatarValorEUR } from '@/hooks/useDashboardFinanceiro';

interface TabelaServicosMaisVendidosProps {
  dados: ServicoMaisVendido[];
}

export function TabelaServicosMaisVendidos({ dados }: TabelaServicosMaisVendidosProps) {
  const { t } = useTranslation();
  if (!dados || dados.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        {t('dashboard.tables.noServicesInPeriod')}
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[40%]">{t('dashboard.tables.serviceColumn')}</TableHead>
          <TableHead className="text-center">{t('dashboard.tables.qtyColumn')}</TableHead>
          <TableHead className="text-right">{t('dashboard.tables.revenueColumn')}</TableHead>
          <TableHead className="w-[25%]">{t('dashboard.tables.shareColumn')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {dados.map((servico, index) => (
          <TableRow key={servico.servicoNome}>
            <TableCell className="font-medium">
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground w-4">#{index + 1}</span>
                {servico.servicoNome}
              </div>
            </TableCell>
            <TableCell className="text-center">
              {servico.quantidade}
            </TableCell>
            <TableCell className="text-right font-medium">
              {formatarValorEUR(servico.valorTotal)}
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <Progress value={servico.percentual} className="h-2 flex-1" />
                <span className="text-xs text-muted-foreground w-10 text-right">
                  {servico.percentual}%
                </span>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
